import React from 'react';
import SVG from 'react-inlinesvg';

const CarouselImagePlaceholder = () => {
	return (
		<SVG
			src="/static/assets/icons/bodyStyles/suv.svg"
			aria-hidden="true"
			className="bg-contrast-med"
			width="100%"
			height="100%"
			style={{
				aspectRatio: '4/3',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				width: '100%',
				maxWidth: '100%',
				height: 'auto'
			}}
			loader={
				<div
					style={{
						aspectRatio: '4/3',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						width: '100%',
						maxWidth: '100%',
						height: 'auto'
					}}
				/>
			}
		/>
	);
};

CarouselImagePlaceholder.propTypes = {};

export default CarouselImagePlaceholder;
